const stagingConfig = {
  segment: {
    enabled: false,
    publicKey: 'LR3TCDRu7vPZfty8FPZsg4Oe1WTmpAtt'
  },
  rudderstack: {
    enabled: true,
    publicKey: '2A59r5cgf9ZJnZBtj6kggLgmQKM'
  },
  sentry: {
    projectId: 237612,
    publicKey: 'cb27762b225f4884b5e035580f1cc289',
    dsn: 'https://cb27762b225f4884b5e035580f1cc289@o104929.ingest.sentry.io/237612'
  }
};

module.exports = stagingConfig;
